module.exports = __webpack_public_path__ + "static/media/ei_board.a05c6e1e.png";